type FrameMap = {
  [key: number]: string
}

type GuideMap = {
  intro: string[]
  animations: {
    welcome: number[]
    talkingSummer: number[]
    talkingWinter: number[]
    freezing: number[]
    onCorrect: number[]
    onFailed: number[]
  }
  frames: {
    summer: FrameMap
    winterCoat: FrameMap
    winterFull: FrameMap
    freezing: FrameMap
  }
  endQuotes: {
    [key: number]: string
  }
}

export const GuideMap: GuideMap = {
  intro: [''],
  animations: {
    welcome: [0, 3, 4, 5, 4, 7, 5, 0, 0, 1, 1],
    talkingSummer: [0, 9, 6, 4, 9, 1, 1, 4],
    talkingWinter: [0, 10, 6, 4, 1, 1, 6, 4],
    freezing: [0, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 1],
    onCorrect: [0, 1, 2, 2, 4, 7, 4, 2, 1, 6, 2],
    onFailed: [0, 6, 6, 5, 7, 4, 6, 6, 6],
  },
  frames: {
    summer: {
      0: require('../assets/guide/lesnik_summer_01.svg').default,
      1: require('../assets/guide/lesnik_summer_02.svg').default,
      2: require('../assets/guide/lesnik_summer_03.svg').default,
      3: require('../assets/guide/lesnik_summer_04.svg').default,
      4: require('../assets/guide/lesnik_summer_05.svg').default,
      5: require('../assets/guide/lesnik_summer_06.svg').default,
      6: require('../assets/guide/lesnik_summer_07.svg').default,
      7: require('../assets/guide/lesnik_summer_08.svg').default,
      8: require('../assets/guide/lesnik_summer_09.svg').default,
      9: require('../assets/guide/lesnik_summer_10.svg').default,
    },
    winterCoat: {
      0: require('../assets/guide/lesnik_winter_a_01.svg').default,
      1: require('../assets/guide/lesnik_winter_a_02.svg').default,
      2: require('../assets/guide/lesnik_winter_a_03.svg').default,
      3: require('../assets/guide/lesnik_winter_a_04.svg').default,
      4: require('../assets/guide/lesnik_winter_a_05.svg').default,
      5: require('../assets/guide/lesnik_winter_a_06.svg').default,
      6: require('../assets/guide/lesnik_winter_a_07.svg').default,
      7: require('../assets/guide/lesnik_winter_a_08.svg').default,
      8: require('../assets/guide/lesnik_winter_a_09.svg').default,
      9: require('../assets/guide/lesnik_winter_a_10.svg').default,
      10: require('../assets/guide/lesnik_winter_a_11.svg').default,
      11: require('../assets/guide/lesnik_winter_a_12.svg').default,
    },
    winterFull: {
      0: require('../assets/guide/lesnik_winter_b_01.svg').default,
      1: require('../assets/guide/lesnik_winter_b_02.svg').default,
      2: require('../assets/guide/lesnik_winter_b_03.svg').default,
      3: require('../assets/guide/lesnik_winter_b_04.svg').default,
      4: require('../assets/guide/lesnik_winter_b_05.svg').default,
      5: require('../assets/guide/lesnik_winter_b_06.svg').default,
      6: require('../assets/guide/lesnik_winter_b_07.svg').default,
      7: require('../assets/guide/lesnik_winter_b_08.svg').default,
      8: require('../assets/guide/lesnik_winter_b_09.svg').default,
      9: require('../assets/guide/lesnik_winter_b_10.svg').default,
      10: require('../assets/guide/lesnik_winter_b_11.svg').default,
      11: require('../assets/guide/lesnik_winter_b_12.svg').default,
    },
    freezing: {
      0: require('../assets/guide/lesnik_winter_freezing.svg').default,
      1: require('../assets/guide/lesnik_winter_freezing_b.svg').default,
    },
  },
  endQuotes: {
    0: 'Výborně! Všechny odpovědi byly správné. Jsi šikulka.',
    1: 'Je to na jedničku, ale s malým mínusem. Mínus můžeš odstranit dalším pokusem.',
    2: 'Není to úplně k zahození, ale… Zkus to znovu! Bude se Ti počítat nejlepší výsledek.',
    3: 'Moc se Ti nedařilo, viď? Neházej flintu do žita a zkus to ještě. Bude se Ti počítat nejlepší výsledek.',
  },
}
